module.exports = __webpack_public_path__ + "static/media/barbell.41c56afa.png";